import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import Restaurants from "./Restaurants";
import FinanceDrivers from "./Drivers";
import FinanceSingleDrivers from "./SingleDriver";
import Settlements from "./Settlements";

class Finance extends Component {
  render() {
    return (
      <Switch>
        <Route path="/finance/restaurants" exact component={Restaurants} />
        <Route path="/finance/drivers" exact component={FinanceDrivers} />
        <Route path="/finance/drivers/:id" component={FinanceSingleDrivers} />
        <Route path="/finance/settlements/:id" exact component={Settlements} />
      </Switch>
    );
  }
}

export default withRouter(Finance);



// WEBPACK FOOTER //
// ./src/components/Finance/index.js